import { readonly, ref, type DeepReadonly, type Ref } from "vue";

export function useState<T>(
  initialState: T,
): [Readonly<Ref<DeepReadonly<T>>>, (newState: T) => void] {
  const state = ref<T>(initialState) as Ref<T>;
  const setState = (newState: T) => {
    state.value = newState;
  };

  return [readonly(state), setState];
}
